import React from 'react';

function BookItem(props) {
    return(
        <tr>
            <td>
                <a 
                    href={props.link}
                    target="_blank"
                    rel="noopener noreferrer">
                    {props.title}
                </a>
            </td>
            <td>
                {props.description}
            </td>
            <td>
                {props.categories}
            </td>
            <td>
            {props.thumbnail ? (
                <img
                    style={{ width: 100 }}
                    src={props.thumbnail}
                    alt={props.id}
                />
                ) : (
                <span>&nbsp;</span>
            )}
            </td>
        </tr>    
    )

}

export default BookItem